define(["exports", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react", "styled-components", "../../themes", "polished", "../AccordionHeader", "../AccordionRegion"], function (_exports, _objectWithoutPropertiesLoose2, _react, _styledComponents, _themes, _polished, _AccordionHeader, _AccordionRegion) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.StyledAccordionRegion = _exports.StyledAccordionHeader = _exports.AccordionHeaderStyle = void 0;
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  _AccordionHeader = _interopRequireDefault(_AccordionHeader);
  _AccordionRegion = _interopRequireDefault(_AccordionRegion);
  var _excluded = ["children"];
  var AccordionHeaderStyle = (0, _styledComponents.default)(_AccordionHeader.default).withConfig({
    displayName: "StyledAccordion__AccordionHeaderStyle",
    componentId: "sc-95qdi3-0"
  })(["", ";background:", ";color:", ";outline:none;padding:8px 32px;position:relative;text-align:left;transition:color 0.4s ", ";&::after{background-color:", ";bottom:0;content:'';height:1px;left:0;position:absolute;width:100%;}&:last-of-type{&::after{display:none;}}h3{font-size:1.6em;font-weight:", ";margin:0;}&:focus{", ";}box-icon{left:16px;position:absolute;transform-origin:50% 50%;transform:translate3d(0,0,0);transition:transform 0.3s ", ",fill 0.4s ", ";will-change:transform;}&[aria-expanded='true']{background:", ";color:", ";box-icon{fill:", ";transform:rotate(-180deg) translate3d(0,-16px,0);}}"], _themes.resetButton, function (_ref) {
    var theme = _ref.theme;
    return theme.colors.lightGray;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.dark;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.easing.ease;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.gray;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.font.semibold;
  }, _themes.focusBoxShadow, function (_ref6) {
    var theme = _ref6.theme;
    return theme.easing.ease;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.easing.ease;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return (0, _polished.rgba)(theme.colors.orange, 0.15);
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.colors.orange;
  }, function (_ref10) {
    var theme = _ref10.theme;
    return theme.colors.orange;
  });
  _exports.AccordionHeaderStyle = AccordionHeaderStyle;

  var StyledAccordionHeader = function StyledAccordionHeader(_ref11) {
    var children = _ref11.children,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref11, _excluded);
    return /*#__PURE__*/_react.default.createElement(AccordionHeaderStyle, rest, /*#__PURE__*/_react.default.createElement("box-icon", {
      type: "solid",
      name: "down-arrow",
      size: "10px"
    }), children);
  };

  _exports.StyledAccordionHeader = StyledAccordionHeader;
  var StyledAccordionRegion = (0, _styledComponents.default)(_AccordionRegion.default).withConfig({
    displayName: "StyledAccordion__StyledAccordionRegion",
    componentId: "sc-95qdi3-1"
  })(["background:", ";padding:8px 16px;"], function (_ref12) {
    var theme = _ref12.theme;
    return theme.colors.white;
  });
  _exports.StyledAccordionRegion = StyledAccordionRegion;
});